import React from 'react';
import ApAuthScreen from './platform/ApAuthScreen';

export default function SignIn() {
  return <ApAuthScreen mode="sign-in" />;
}
